import { NavLink } from "react-router-dom";
import swal from "sweetalert";
import { deleteUser } from "../../http/index";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const RowAdmin = ({index,data}) =>
{
    const showDialog = () => {
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this admin!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
        .then((willDelete) => {
            if (willDelete) {
                deleteUser({ id: data.id })
                .then(res => {
                    if(res.success){
                        toast.success('Admin deleted successfully!');
                        window.location.reload();
                    } else {
                        toast.error('Failed to delete admin!');
                    }
                })
            }
        });
    }

    return(
        <tr>
            <td>{index}</td>
            <td><figure className="avatar"> <img src={data.image} alt={data.name}/> </figure></td>
            <td>{data.name}</td>
            <td>{data.email}</td>
            <td>{data.mobile}</td>
            <td><div className={`badge ${data.status==='Active' ? 'badge-primary' :'badge-danger'}`}>{data.status}</div></td>
            <td>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <NavLink to={`/admin/${data.id}`} className="btn btn-secondary">Detail</NavLink>
                    <button className='btn btn-danger' onClick={showDialog}><i className="fas fa-trash-alt"></i></button>
                </div>
            </td>
        </tr>
    );
}

export default RowAdmin;